import React, { useState, Fragment, useContext, useEffect } from "react";
import { Login } from "../../components/backgrounds/Login";
import { HttpRequest } from "../../services/httpRequest";
import { useNavigate } from "react-router-dom";
import { SuccessAlert } from "../../components/alerts/successAlert";
import { RecaptchaView } from "../../components/captcha/recaptcha";
import { ErrorAlert } from "../../components/alerts/errorAlert";
import { WarningAlert } from "../../components/alerts/warningAlert";
import { AuthContext } from "../../context/Auth/AuthContext";

export function SigninPage() {
  const { isValidReCaptcha, alertSignIn, updateAlertSignIn } = useContext(AuthContext);
  const navigate = useNavigate();

  const [doc, setDoc] = useState("");
  const [messsageAlert, setMessageAlert] = useState("");
  const [alertSession, setAlertSession] = useState(false);
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [isOpenWarning, setIsOpenWarning] = useState(false);
  const [viewalert, setViewalert] = useState(false);
  const [channelOtp, setChannelOtp] = useState({ channel: "S" });

  const handleChange = (e) => {
    const { value } = e.target;
    setDoc(value);
  };

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(isOpen);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(isOpen);
    }
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  const handleChangeChannel = (channel) => {
    setChannelOtp({ channel: channel });
    return;
  }

  const handleSubmit = async (event) => {
    handleClearStateAlert();
    try {
      event.preventDefault();

      if (!isValidReCaptcha)
        return handleOpenAlert(
          "error",
          "Debe validar el captcha para continuar .",
          true
        );

      let payload = Object.assign({}, { doc: doc, channelOtp: channelOtp.channel });

      const responseService = await HttpRequest.loginRequestSms(payload);

      //console.log("imprimiendo responseService", responseService);

      if (responseService.code === "ERR_NETWORK") {
        handleOpenAlert(
          "error",
          "Ups! Ha ocurrido un error de conexión, intente más tarde.",
          true
        );
        setDoc("");
        return;
      }

      if (responseService.error) {
        if (responseService.message.code === "NOTEXISTUSER") {
          handleOpenAlert(
            "error",
            "Ups! El usuario no existe con el documento ingresado.",
            true
          );
          setDoc("");
          return setTimeout(() => {
            navigate("/registrarse");
          }, 2000);
        } else if (responseService.message.code === "ACCOUNTBLOCK") {
          handleOpenAlert(
            "error",
            `Ups! ${responseService.message.message}`,
            true
          );
          setDoc("");
          return;
        } else if (responseService.message.code === "INVALIDCREDENTIALS") {
          handleOpenAlert(
            "error",
            `Ups! ${responseService.message.message}`,
            true
          );
          setDoc("");
          return;
        }

        handleOpenAlert(
          "error",
          "Ups! Error interno, intenta nuevamente",
          true
        );
        setDoc("");
        return;
      }

      let phoneNumber = responseService.message.response.phone;
      let emailUser = responseService.message.response.mail;

      handleOpenAlert(
        "success",
        channelOtp.channel === 'W' ?
          "Te enviamos un código a tu telefono registrado!"
          :
          "Te enviamos un código a tu correo registrado!"
        ,
        true
      );

      updateAlertSignIn({
        message: "",
        show: false,
        title: ""
      });

      setAlertSession(false);
      setIsOpenWarning(false);

      setTimeout(() => {
        return navigate("/autenticarse", {
          replace: true,
          state: { phone: phoneNumber, doc: doc, email: emailUser, channel: channelOtp.channel },
        });
      }, 2000);
    } catch (error) {
      console.log(error);
      return navigate("/ingresar");
    }
  };

  useEffect(() => {
    if (alertSignIn) {
      if ('show' in alertSignIn) {
        let showAlertSession = alertSignIn?.show;
        if (showAlertSession === true) {
          setAlertSession(true);
          setIsOpenWarning(true);
          setMessageAlert(alertSignIn?.message);
        }
      }
    }

    const isSignin = localStorage.getItem("is_signin");
    const tokenSession = localStorage.getItem("token");

    if (isSignin && tokenSession) {
      return navigate("/micredito");
    }
    return;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Fragment>
      {viewalert && (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>

        </>
      )}

      {alertSession && (
        <>
          <WarningAlert isOpen={isOpenWarning} message={messsageAlert} permanent={true}></WarningAlert>
        </>
      )}

      <Login
        title="Ingresa a tu cuenta"
        description="Digita tu número de documento para verificar tu cuenta"
        form={
          <form
            action="#"
            method="POST"
            className="space-y-6 h-96"
            onSubmit={handleSubmit}
          >
            <div>
              <label htmlFor="first-name" className="block text-sm font-medium">
                Número de documento
              </label>
              <div>
                <input
                  onChange={handleChange}
                  type="number"
                  name="documento"
                  id="documento"
                  autoComplete="off"
                  spellCheck={false}
                  required={true}
                  minLength="6"
                  maxLength="10"
                  pattern="[0-9]+"
                  value={doc}
                  className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                />
              </div>
              <div className="pt-12">
                <RecaptchaView></RecaptchaView>
              </div>
            </div>
            <div className="block">
              <div className="text-center pb-4">
                <span className="font-sm text-grayP">Elige cómo quieres recibir el código de verificación</span>
              </div>
              <div className="flex">



                <div className="w-full pr-1">
                  <button
                    onClick={(e) => handleChangeChannel("W")}
                    type="submit"
                    className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-lg text-white font-semibold bg-purple transition duration-300 hover:bg-purpleDark focus:outline-none hover:scale-110"

                  >
                    <div className="flex">
                      Whatsapp
                      <div className="grid content-center pl-2"></div>
                    </div>
                  </button>
                </div>

                <div className="w-full">
                  <button
                    onClick={(e) => handleChangeChannel("E")}
                    type="submit"
                    className="w-full text-lg flex justify-center py-2 px-4 border border-transparent rounded-full font-semibold text-tdark tracking-tight bg-purpleLight transition duration-300 hover:bg-purple hover:text-white focus:outline-none"
                  >
                    <div className="flex">
                      Email
                      <div className="grid content-center pl-2"></div>
                    </div>
                  </button>
                </div>

              </div>
            </div>
            <div className="pt-6 flex justify-center pb-16">
              <span className="">
                ¿No eres cliente?
                <a href="/registrarse" className="text-purple underline pl-2">
                  Únete a nuestro mundo
                </a>
              </span>
            </div>
          </form>
        }
      />
    </Fragment>
  );
}
